import { pickI18n } from './format';
import type { Locale } from './i18n';

/**
 * 票種顯示名解析：優先用 pricing 規則設定之 display_name_i18n，否則退回內建多語標籤，
 * 最後退回票種代碼。供 KIOSK / 內部多票種動態渲染共用。
 */
const LABELS: Record<string, [string, string, string]> = {
  adult: ['大人', 'Adult', '大人'],
  senior: ['敬老', 'Senior', 'シニア'],
  child: ['兒童', 'Child', '子供'],
  // 業主價目表的兒童分兩段（見 migration 20260819050000）；年齡直接寫在標籤上，
  // 顧客不必猜哪一段是哪個年紀
  child_3_5: ['兒童 3-5 歲', 'Child 3-5', '子供 3〜5歳'],
  child_6_11: ['兒童 6-11 歲', 'Child 6-11', '子供 6〜11歳'],
  infant: ['幼兒', 'Infant', '幼児'],
  early_bird: ['早鳥', 'Early bird', '早割'],
  package_family: ['家庭套裝', 'Family', '家族'],
  custom: ['自訂', 'Custom', 'カスタム'],
};
const IDX: Record<Locale, number> = { 'zh-TW': 0, en: 1, ja: 2 };

export function ticketTypeLabel(
  ticketType: string,
  displayNameI18n: Record<string, string> | null,
  locale: Locale,
): string {
  if (displayNameI18n) {
    const v = pickI18n(displayNameI18n, '', locale);
    if (v) return v;
  }
  return LABELS[ticketType]?.[IDX[locale]] ?? ticketType;
}
